export const TRANSACTION_STATUS = [
  { value: '', label: 'All' },
  { value: 'to_pay', label: 'To Pay' },
  { value: 'paid', label: 'Paid' },
  { value: 'completed', label: 'Completed' },
  { value: 'rejected', label: 'Rejected' },
];
